import axios from 'axios';
import store from '../store';
import router from "../router";

class TradesRepository {

    constructor(){
        this.basePath = store.state.backend;
    }

    allTradesOfExternalUser(userId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/trades/user/external?userId=${userId}`, {headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }

    filteredTradesOfUser(filter) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/trades/filter`, {headers: headers, params: filter});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }

    filteredTradesOfExternalUser(filter) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/trades/filter/external`, {headers: headers, params: filter});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }

    createTrade(trade) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/trades`, trade, {headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }

    updateTrade(trade) {
        let headers = {'Authorization': store.state.token};
        let response = axios.put(`${this.basePath}/ext/trades`, trade, {headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }

    deleteTrade(tradeId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.delete(`${this.basePath}/trades/${tradeId}`, {headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }

    deleteMultipleTrades(trades) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/trades/multiple`, trades, {headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }

    updateTradeNote(tradeId, tradeNote) {
        let headers = {'Authorization': store.state.token};
        let data = {
            tradeId: tradeId,
            tradeNote: tradeNote,
        };
        let response = axios.post(`${this.basePath}/ext/trades/note`, data, {headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }

    importTrades(trades) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/trades/add-by-import`, trades, {headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }

    getOverallMetrics() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/trades/overall-metrics`, {headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }
}

export default new TradesRepository();
